import { PlayerConsumerProps } from './types'
import Player from './components/player'
import PlayerThumb from './components/playerThumb'
import * as S from './styles'

import TransmissionHelper from 'modules/transmission/helper'
import { Status } from 'modules/transmission/types'

const PlayerConsumer = ({
  className,
  embedUrl,
  leadCode,
  isHotmartProvider,
  transmission
}: PlayerConsumerProps) => {
  const containerProps = { className }
  const isPlaybackActive = TransmissionHelper.isPlaybackActive(transmission, isHotmartProvider)
  const isPlaybackAvailable = TransmissionHelper.isPlaybackAvailable(transmission, isHotmartProvider)

  if (!isPlaybackActive && !isPlaybackAvailable) {
    return (
      <PlayerThumb
        {...containerProps}
        transmission={transmission}
        hideCountdown={transmission.status === Status.COMPLETED} />
    )
  }

  return (
    <S.Container {...containerProps}>
      <Player transmission={transmission} embedUrl={embedUrl} leadCode={leadCode} />
    </S.Container>
  )
}

export default PlayerConsumer

